import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { totalStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsTotal";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

totalStyles.container = mergeToNew(totalStyles.container, {
    css: css`
        background-color: ${getColor("secondary")};
        padding: 20px;
    `,
});

totalStyles.totalLabelText = mergeToNew(totalStyles.totalLabelText, {
    color: "text.accent",
});

totalStyles.totalValueText = mergeToNew(totalStyles.totalValueText, {
    color: "text.accent",
});
